import React from 'react';
import DirectoryTabs from './DirectoryTabs';
import { ToastContainer } from 'react-toastify';

const Result = () => {
  return (
    <>
      <ToastContainer />
      <div className="user-section">
        <DirectoryTabs />
      </div>
    </>
  );
};

export default Result;
